import React from 'react'
import GridBlock from "components/GridBlock";
import PropTypes from "prop-types";
import DateTimePicker from "components/DateTimePicker";
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/styles";
import BoldTypography from "components/BoldTypography";

const useStyle = makeStyles(theme => ({
    root: {},
    picker: {
        width: 400,
        marginRight: theme.spacing(3)
    },
    stageHead: {
        marginTop: theme.spacing(4)
    }
}))

function PurchasingGroupStage1ScheduleForm(
    {
        formikProps,
        schedule,
        editable
    }) {
    const classes = useStyle();

    return (<GridBlock
        column
    >

        <BoldTypography>{Tr('purchasing_group_joining_stage')}</BoldTypography>
        <GridBlock>
            <DateTimePicker
                className={classes.picker}
                formikProps={formikProps}
                id="joiningStartDate"
                label={Tr('purchase_group_stage_start_date')}
                required={schedule.joiningStartDateEditable}
                disabled={!editable || !schedule.joiningStartDateEditable}
            />
            <DateTimePicker
                className={classes.picker}
                formikProps={formikProps}
                id="joiningEndDate"
                label={Tr('purchase_group_stage_end_date')}
                required={schedule.joiningEndDateEditable}
                disabled={!editable || !schedule.joiningEndDateEditable}
            />
        </GridBlock>

        <BoldTypography className={classes.stageHead}>{Tr('purchasing_group_opinion_stage')}</BoldTypography>
        <GridBlock>
            <DateTimePicker
                className={classes.picker}
                formikProps={formikProps}
                id="opinionStartDate"
                label={Tr('purchase_group_stage_start_date')}
                required={schedule.opinionStartDateEditable}
                disabled={!editable || !schedule.opinionStartDateEditable}
            />
            <DateTimePicker
                className={classes.picker}
                formikProps={formikProps}
                id="opinionEndDate"
                label={Tr('purchase_group_stage_end_date')}
                required={schedule.opinionEndDateEditable}
                disabled={!editable || !schedule.opinionEndDateEditable}
            />
        </GridBlock>

        <BoldTypography className={classes.stageHead}>{Tr('purchasing_group_submission_stage')}</BoldTypography>
        <GridBlock>
            <DateTimePicker
                className={classes.picker}
                formikProps={formikProps}
                id="submissionStartDate"
                label={Tr('purchase_group_stage_start_date')}
                required={schedule.submissionStartDateEditable}
                disabled={!editable || !schedule.submissionStartDateEditable}
            />
            <DateTimePicker
                className={classes.picker}
                formikProps={formikProps}
                id="submissionEndDate"
                label={Tr('purchase_group_stage_end_date')}
                required={schedule.submissionEndDateEditable}
                disabled={!editable || !schedule.submissionEndDateEditable}
            />
        </GridBlock>

    </GridBlock>)
}

PurchasingGroupStage1ScheduleForm.propTypes = {
    schedule: PropTypes.shape({
        joiningStartDateEditable: PropTypes.bool.isRequired,
        joiningEndDateEditable: PropTypes.bool.isRequired,
        opinionStartDateEditable: PropTypes.bool.isRequired,
        opinionEndDateEditable: PropTypes.bool.isRequired,
        submissionStartDateEditable: PropTypes.bool.isRequired,
        submissionEndDateEditable: PropTypes.bool.isRequired,
    }).isRequired
}

export default PurchasingGroupStage1ScheduleForm;